import type { ExerciseAvatarDemonstration } from "@/lib/fitnessDemonstration";

/** Technically reviewed original motions, exact variants only. */
const catalog: { aliases: string[]; demonstration: ExerciseAvatarDemonstration }[] = [
  {
    "aliases": [
      "pull up",
      "pull ups",
      "pullup",
      "pullups",
      "barra fixa"
    ],
    "demonstration": {
      "id": "pull-up",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/pull-up.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s2",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/2b3cd8321314fe56cdd82520b6fdecea70eb39c5/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural18-neck/README.md",
      "equipment": {
        "kind": "pull-up",
        "metadataUrl": "/fitness/authored/pull-up.equipment.json"
      },
      "bounds": {
        "min": [
          -0.74,
          0,
          -0.51
        ],
        "max": [
          0.74,
          2.373887,
          0.19
        ]
      }
    }
  },
  {
    "aliases": [
      "bench press",
      "barbell bench press",
      "flat barbell bench press",
      "supino reto",
      "supino reto com barra"
    ],
    "demonstration": {
      "id": "bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s5",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/flat-three-supported/reproduce-flat-three.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000003,
          -9.999999989311498e-7,
          -1.140001
        ],
        "max": [
          0.7500010000000001,
          1.2150010005960468,
          0.8143352992774199
        ]
      }
    }
  },
  {
    "aliases": [
      "overhead press",
      "barbell overhead press",
      "standing barbell overhead press",
      "desenvolvimento com barra"
    ],
    "demonstration": {
      "id": "overhead-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/overhead-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s6",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/remaining-upper-four-natural-repair/author-proof/frozen-four-reproduction-v1/reproduce-four.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/overhead-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7050010000000003,
          0,
          -0.145794
        ],
        "max": [
          0.7050010000000003,
          2.160001000596047,
          0.34500100059604666
        ]
      }
    }
  },
  {
    "aliases": [
      "barbell row",
      "barbell rows",
      "bent over barbell row",
      "remada com barra",
      "remada curvada com barra"
    ],
    "demonstration": {
      "id": "barbell-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/barbell-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s7",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/barbell-row14/reproduce-row14.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/barbell-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7050010000000004,
          -0.000001016940352151437,
          -0.29225354262368247
        ],
        "max": [
          0.7050010000000002,
          1.3431785441313566,
          0.6005836915177144
        ]
      }
    }
  },
  {
    "aliases": [
      "dumbbell curl",
      "dumbbell curls",
      "dumbbell biceps curl",
      "rosca com haltere",
      "rosca com halteres"
    ],
    "demonstration": {
      "id": "dumbbell-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/dumbbell-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s8",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural13-four/reproduce-four-db13.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/dumbbell-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.512827512001201,
          -9.999999993415157e-7,
          -0.1454588950637432
        ],
        "max": [
          0.5121668308173891,
          1.8157533454165682,
          0.3832777534211977
        ]
      }
    }
  },
  {
    "aliases": [
      "tricep dip",
      "triceps dip",
      "tricep dips",
      "triceps dips",
      "parallel bar dip",
      "parallel bar dips",
      "mergulho nas paralelas"
    ],
    "demonstration": {
      "id": "tricep-dip",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/tricep-dip.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s9",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/501663c3931e7ea59ed820fe2767963eb7181907/docs/qa/fitness-completion-20261015/natural-grip-23-24/README.md",
      "equipment": {
        "kind": "parallel-bars",
        "metadataUrl": "/fitness/authored/tricep-dip.equipment.json"
      },
      "bounds": {
        "min": [
          -0.364978,
          0,
          -0.87
        ],
        "max": [
          0.365651,
          2.207092,
          0.82
        ]
      }
    }
  },
  {
    "aliases": [
      "lateral raise",
      "lateral raises",
      "dumbbell lateral raise",
      "dumbbell lateral raises",
      "elevação lateral",
      "elevação lateral com halteres"
    ],
    "demonstration": {
      "id": "lateral-raise",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/lateral-raise.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s10",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural13-four/reproduce-four-db13.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/lateral-raise.equipment.json"
      },
      "bounds": {
        "min": [
          -0.871484599655228,
          -9.999999993415157e-7,
          -0.14537474135335687
        ],
        "max": [
          0.871484624388113,
          1.8157533454165682,
          0.17458525768422936
        ]
      }
    }
  },
  {
    "aliases": [
      "face pull",
      "face pulls"
    ],
    "demonstration": {
      "id": "face-pull",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/face-pull.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s17",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/face-pull-routing-v1/exact-sources-and-proofs.zip",
      "equipment": {
        "kind": "cable",
        "metadataUrl": "/fitness/authored/face-pull.equipment.json"
      },
      "bounds": {
        "min": [
          -0.450925,
          -9.991059303969254e-7,
          -0.145415
        ],
        "max": [
          0.451556,
          1.815753,
          1.6500009999999998
        ]
      }
    }
  },
  {
    "aliases": [
      "dumbbell fly",
      "dumbbell flyes",
      "dumbbell flies",
      "flat dumbbell fly",
      "crucifixo com haltere",
      "crucifixo com halteres"
    ],
    "demonstration": {
      "id": "dumbbell-fly",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/dumbbell-fly.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored s18",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/flat-three-supported/reproduce-flat-three.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/dumbbell-fly.equipment.json"
      },
      "bounds": {
        "min": [
          -0.835795786903529,
          -9.999999989311498e-7,
          -1.140001
        ],
        "max": [
          0.8357958114399668,
          1.1711369367660933,
          0.8143352992774199
        ]
      }
    }
  },
  {
    "aliases": [
      "cable crunch",
      "cable crunches",
      "kneeling cable crunch",
      "abdominal no cabo"
    ],
    "demonstration": {
      "id": "cable-crunch",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/cable-crunch.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored cable-crunch candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/core-cable-crunch-natural9-a1-final/reproduce.cjs",
      "equipment": {
        "kind": "cable",
        "metadataUrl": "/fitness/authored/cable-crunch.equipment.json"
      },
      "bounds": {
        "min": [
          -0.270139,
          -9.991059303969254e-7,
          -0.574666
        ],
        "max": [
          0.270085,
          1.8700010002980232,
          1.5500009999999997
        ]
      }
    }
  },
  {
    "aliases": [
      "deadlift",
      "deadlifts",
      "barbell deadlift",
      "levantamento terra"
    ],
    "demonstration": {
      "id": "deadlift",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/deadlift.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s4",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.6500010014723521,
          -0.000011391164732093234,
          -0.3009640789261667
        ],
        "max": [
          0.6500009985276486,
          1.8153781937823517,
          0.6167116168301532
        ]
      },
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/deadlift.equipment.json"
      }
    }
  },
  {
    "aliases": [
      "leg press"
    ],
    "demonstration": {
      "id": "leg-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/leg-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s11",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.455001,
          0,
          -0.752158
        ],
        "max": [
          0.455001,
          1.511128,
          0.825998
        ]
      },
      "equipment": {
        "kind": "leg-press",
        "metadataUrl": "/fitness/authored/leg-press.equipment.json"
      }
    }
  },
  {
    "aliases": [
      "lunge",
      "lunges",
      "forward lunge",
      "forward lunges",
      "avanço",
      "avanços",
      "afundo à frente"
    ],
    "demonstration": {
      "id": "lunges",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/lunges.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s12",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.3423051800470014,
          -0.0009091105027250686,
          -0.1451913422209147
        ],
        "max": [
          0.341953953766557,
          1.8205699093960621,
          0.8055937744559657
        ]
      }
    }
  },
  {
    "aliases": [
      "romanian deadlift",
      "barbell romanian deadlift",
      "romanian deadlift barbell",
      "levantamento terra romeno"
    ],
    "demonstration": {
      "id": "romanian-deadlift",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/romanian-deadlift.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s15",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.6500010014723522,
          -0.0000039662793753010455,
          -0.3915128828373719
        ],
        "max": [
          0.6500009985276487,
          1.8158910891378153,
          0.5255718293002561
        ]
      },
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/romanian-deadlift.equipment.json"
      }
    }
  },
  {
    "aliases": [
      "calf raise",
      "calf raises",
      "standing calf raise",
      "standing calf raises",
      "elevação de panturrilha"
    ],
    "demonstration": {
      "id": "calf-raise",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/calf-raise.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s16",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.33144012314569815,
          -0.000917156003146098,
          -0.1451913422209147
        ],
        "max": [
          0.3311102685147893,
          1.855429055330771,
          0.22267788911352482
        ]
      }
    }
  },
  {
    "aliases": [
      "leg curl",
      "leg curls"
    ],
    "demonstration": {
      "id": "leg-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/leg-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored s19",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerBody.ts",
      "bounds": {
        "min": [
          -0.45002,
          0,
          -0.958881
        ],
        "max": [
          0.45212,
          1.211757,
          0.878548
        ]
      },
      "equipment": {
        "kind": "leg-curl",
        "metadataUrl": "/fitness/authored/leg-curl.equipment.json"
      }
    }
  },
  {
    "aliases": [
      "ab wheel",
      "kneeling ab wheel",
      "kneeling ab wheel rollout"
    ],
    "demonstration": {
      "id": "kneeling-ab-wheel",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/kneeling-ab-wheel.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored kneeling ab wheel candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/501663c3931e7ea59ed820fe2767963eb7181907/docs/qa/fitness-completion-20261015/natural-grip-23-24/README.md",
      "bounds": {
        "min": [
          -0.26073,
          -0.000001,
          -0.454559
        ],
        "max": [
          0.275213,
          0.703841,
          1.751613
        ]
      },
      "equipment": {
        "kind": "ab-wheel",
        "metadataUrl": "/fitness/authored/kneeling-ab-wheel.equipment.json"
      }
    }
  },
  {
    "aliases": [
      "Reverse Crunch"
    ],
    "demonstration": {
      "id": "reverse-crunch",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/reverse-crunch.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored reverse-crunch candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.5301321287829581,
          0.0009704897131513806,
          -0.8769500596750286
        ],
        "max": [
          0.5301681429739006,
          1.0082581961087527,
          0.5239087299553444
        ]
      }
    }
  },
  {
    "aliases": [
      "Leg Raise",
      "Supine Leg Raise"
    ],
    "demonstration": {
      "id": "supine-leg-raise",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/supine-leg-raise.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored supine-leg-raise candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.34512518155952987,
          0.00005679988993004957,
          -0.8769500596750281
        ],
        "max": [
          0.34411527304625533,
          1.1086549403111334,
          0.9430526142819008
        ]
      }
    }
  },
  {
    "aliases": [
      "Dead Bug"
    ],
    "demonstration": {
      "id": "dead-bug",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/dead-bug.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored dead-bug candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.2522740592115481,
          0.0002506520636554772,
          -1.1917719973350192
        ],
        "max": [
          0.25235593141690443,
          0.7962533779319824,
          0.9430526142819008
        ]
      }
    }
  },
  {
    "aliases": [
      "Bicycle Crunch"
    ],
    "demonstration": {
      "id": "bicycle-crunch",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/bicycle-crunch.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored bicycle-crunch candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.4591583946565287,
          0.0007184668415776642,
          -0.8413158272542773
        ],
        "max": [
          0.4588925902839794,
          0.745500614937548,
          0.8904635235099533
        ]
      }
    }
  },
  {
    "aliases": [
      "Oblique Crunch",
      "Cross Body Oblique Crunch"
    ],
    "demonstration": {
      "id": "cross-body-oblique-crunch",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/cross-body-oblique-crunch.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored cross-body-oblique-crunch candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.4529057033266811,
          1.141131407908476e-15,
          -0.8772805262359136
        ],
        "max": [
          0.45256741447052434,
          0.46162043282184884,
          0.8543342992774197
        ]
      }
    }
  },
  {
    "aliases": [
      "Russian Twist",
      "Seated Russian Twist"
    ],
    "demonstration": {
      "id": "seated-russian-twist",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-russian-twist.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-russian-twist candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.33129691015718954,
          8.775808551528365e-16,
          -0.4302061683686203
        ],
        "max": [
          0.33164513030718057,
          0.9301869608406449,
          0.8543342992774201
        ]
      }
    }
  },
  {
    "aliases": [
      "Mountain Climber",
      "Mountain Climbers"
    ],
    "demonstration": {
      "id": "mountain-climber",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/mountain-climber.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored mountain-climber candidate",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCoreVariants.ts",
      "bounds": {
        "min": [
          -0.25335058111103603,
          0.0002372360540194591,
          -0.8992953405628733
        ],
        "max": [
          0.25343225762944566,
          0.6475897301170723,
          0.8785479243653347
        ]
      }
    }
  },
  {
    "aliases": [
      "Chin-up"
    ],
    "demonstration": {
      "id": "chin-up",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/chin-up.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored chin-up",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/2b3cd8321314fe56cdd82520b6fdecea70eb39c5/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural18-neck/README.md",
      "equipment": {
        "kind": "pull-up",
        "metadataUrl": "/fitness/authored/chin-up.equipment.json"
      },
      "bounds": {
        "min": [
          -0.74,
          0,
          -0.51
        ],
        "max": [
          0.74,
          2.373887,
          0.212595
        ]
      }
    }
  },
  {
    "aliases": [
      "Incline Bench Press"
    ],
    "demonstration": {
      "id": "incline-barbell-bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/incline-barbell-bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored incline-barbell-bench-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/bench-four-public-integration/reproduce-reviewed-bench.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/incline-barbell-bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000003,
          -0.000001,
          -1.1466610689897065
        ],
        "max": [
          0.750001,
          1.5644228438043903,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Decline Bench Press"
    ],
    "demonstration": {
      "id": "decline-barbell-bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/decline-barbell-bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored decline-barbell-bench-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/decline-barbell-natural14-v6-lower-chest/reproduce.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/decline-barbell-bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000004,
          -9.995529651637682e-7,
          -1.0548481176202966
        ],
        "max": [
          0.750001,
          1.3021612881194038,
          0.834335
        ]
      }
    }
  },
  {
    "aliases": [
      "Incline Dumbbell Press"
    ],
    "demonstration": {
      "id": "incline-dumbbell-bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/incline-dumbbell-bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored incline-dumbbell-bench-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/bench-four-public-integration/reproduce-reviewed-bench.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/incline-dumbbell-bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.45894842353023474,
          -0.000001,
          -1.1466610689897065
        ],
        "max": [
          0.45916834045811916,
          1.509525710585431,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Incline Dumbbell Fly"
    ],
    "demonstration": {
      "id": "incline-dumbbell-fly",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/incline-dumbbell-fly.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored incline-dumbbell-fly",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/bench-four-public-integration/reproduce-reviewed-bench.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/incline-dumbbell-fly.equipment.json"
      },
      "bounds": {
        "min": [
          -0.8268536009725902,
          -0.000001,
          -1.1466610689897065
        ],
        "max": [
          0.8220678090962804,
          1.4986346571530509,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "One-Arm Dumbbell Row"
    ],
    "demonstration": {
      "id": "one-arm-supported-dumbbell-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/one-arm-supported-dumbbell-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored one-arm-supported-dumbbell-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/supported-row-natural13-v1/reproduction/exact-candidate-and-proofs.zip",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/one-arm-supported-dumbbell-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.292225,
          -9.991059303969254e-7,
          -0.88801
        ],
        "max": [
          0.3300009964237213,
          1.049381,
          0.8300009999999999
        ]
      }
    }
  },
  {
    "aliases": [
      "Dumbbell Shoulder Press"
    ],
    "demonstration": {
      "id": "standing-dumbbell-shoulder-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-dumbbell-shoulder-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-dumbbell-shoulder-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/remaining-upper-four-natural-repair/author-proof/frozen-four-reproduction-v1/reproduce-four.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-dumbbell-shoulder-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.4400010000000002,
          0,
          -0.145243
        ],
        "max": [
          0.440001,
          2.085000997615815,
          0.21500099761581445
        ]
      }
    }
  },
  {
    "aliases": [
      "Barbell Curl"
    ],
    "demonstration": {
      "id": "standing-barbell-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-barbell-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-barbell-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredUpperVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/standing-barbell-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6574472517212403,
          6.584841578389901e-16,
          -0.146184
        ],
        "max": [
          0.657447250820875,
          1.8157523398470508,
          0.5209216177426156
        ]
      }
    }
  },
  {
    "aliases": [
      "Alternating Dumbbell Curl"
    ],
    "demonstration": {
      "id": "standing-alternating-dumbbell-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-alternating-dumbbell-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-alternating-dumbbell-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural13-four/reproduce-four-db13.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-alternating-dumbbell-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.512827512001201,
          -9.999999993415157e-7,
          -0.1454588950637432
        ],
        "max": [
          0.5121668308173891,
          1.8157533454165682,
          0.3832777534211977
        ]
      }
    }
  },
  {
    "aliases": [
      "Hammer Curl"
    ],
    "demonstration": {
      "id": "standing-dumbbell-hammer-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-dumbbell-hammer-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-dumbbell-hammer-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/natural13-four/reproduce-four-db13.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-dumbbell-hammer-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.3592934049706684,
          -9.999999993415157e-7,
          -0.1615479592225388
        ],
        "max": [
          0.3493435283277014,
          1.8157533454165682,
          0.38999713520728213
        ]
      }
    }
  },
  {
    "aliases": [
      "Reverse Curl"
    ],
    "demonstration": {
      "id": "standing-barbell-reverse-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-barbell-reverse-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-barbell-reverse-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/remaining-upper-four-natural-repair/author-proof/frozen-four-reproduction-v1/reproduce-four.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/standing-barbell-reverse-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6555884541296472,
          0,
          -0.146276
        ],
        "max": [
          0.6555884531157303,
          1.815753,
          0.5516907304075586
        ]
      }
    }
  },
  {
    "aliases": [
      "Incline Dumbbell Curl"
    ],
    "demonstration": {
      "id": "seated-incline-dumbbell-curl",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-incline-dumbbell-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-incline-dumbbell-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/bench-four-public-integration/reproduce-reviewed-bench.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/seated-incline-dumbbell-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.5128275120012008,
          -0.000001,
          -0.9398567158514989
        ],
        "max": [
          0.5121668308173891,
          1.381656,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Skull Crusher"
    ],
    "demonstration": {
      "id": "flat-barbell-skull-crusher",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/flat-barbell-skull-crusher.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored flat-barbell-skull-crusher",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/flat-three-supported/reproduce-flat-three.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/flat-barbell-skull-crusher.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6379185617693179,
          -9.999999989311498e-7,
          -1.140001
        ],
        "max": [
          0.6379185596718547,
          1.2496640024158312,
          0.8143352992774199
        ]
      }
    }
  },
  {
    "aliases": [
      "Triceps Kickback"
    ],
    "demonstration": {
      "id": "supported-one-arm-dumbbell-kickback",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/supported-one-arm-dumbbell-kickback.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored supported-one-arm-dumbbell-kickback",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/research/fitness-rea-20261015/upper-registered-repair-qa/supported-kick-natural13-v1/reproduction/exact-candidate-and-proofs.zip",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/supported-one-arm-dumbbell-kickback.equipment.json"
      },
      "bounds": {
        "min": [
          -0.539773,
          -9.991059303969254e-7,
          -0.88801
        ],
        "max": [
          0.3300009964237213,
          1.072211852170195,
          0.8300009999999999
        ]
      }
    }
  },
  {
    "aliases": [
      "One-Arm Triceps Extension"
    ],
    "demonstration": {
      "id": "standing-one-arm-overhead-dumbbell-extension",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-one-arm-overhead-dumbbell-extension.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-one-arm-overhead-dumbbell-extension",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/remaining-upper-four-natural-repair/author-proof/frozen-four-reproduction-v1/reproduce-four.py",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-one-arm-overhead-dumbbell-extension.equipment.json"
      },
      "bounds": {
        "min": [
          -0.26745123685766636,
          0,
          -0.5068371732000032
        ],
        "max": [
          0.282729,
          2.1470213272436105,
          0.174585
        ]
      }
    }
  },
  {
    "aliases": [
      "Flat Dumbbell Bench Press"
    ],
    "demonstration": {
      "id": "flat-dumbbell-bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/flat-dumbbell-bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored flat-dumbbell-bench-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredUpperVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/flat-dumbbell-bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.4600000000000003,
          1.0688500501105218e-15,
          -1.1400000000000001
        ],
        "max": [
          0.46,
          1.1577501262345713,
          0.8143342992774198
        ]
      }
    }
  },
  {
    "aliases": [
      "Front Squat"
    ],
    "demonstration": {
      "id": "plan-front-squat",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-front-squat.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored plan-front-squat",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/front-clean-rack-v3/reproduction/reproduce.py",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/plan-front-squat.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010001575529,
          -0.000017,
          -0.2367
        ],
        "max": [
          0.7500009998430315,
          1.815753,
          0.35223
        ]
      }
    }
  },
  {
    "aliases": [
      "Pause Squat"
    ],
    "demonstration": {
      "id": "plan-pause-squat",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-pause-squat.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored plan-pause-squat",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/plan-pause-squat.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000003,
          -0.00002938890250234655,
          -0.3339827399120166
        ],
        "max": [
          0.7500010000000003,
          1.815753345416568,
          0.28156029795968507
        ]
      }
    }
  },
  {
    "aliases": [
      "Sumo Squat"
    ],
    "demonstration": {
      "id": "free-glutes-sumo",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-sumo.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-glutes-sumo",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "bounds": {
        "min": [
          -0.44405908212456585,
          -4.153556040539906e-17,
          -0.24527419529095906
        ],
        "max": [
          0.4440585222918198,
          1.789893975473771,
          0.6183629299694433
        ]
      }
    }
  },
  {
    "aliases": [
      "Bulgarian Split Squat"
    ],
    "demonstration": {
      "id": "free-legs-bulgaro",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-legs-bulgaro.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-legs-bulgaro",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/free-legs-bulgaro.equipment.json"
      },
      "bounds": {
        "min": [
          -0.40000100596046445,
          -0.000004141665280276291,
          -1.350001
        ],
        "max": [
          0.40000100596046445,
          1.6957533406481964,
          0.5488797727251924
        ]
      }
    }
  },
  {
    "aliases": [
      "Stiff-Leg Deadlift"
    ],
    "demonstration": {
      "id": "free-legs-stiff",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-legs-stiff.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-legs-stiff",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/free-legs-stiff.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6500010014723521,
          -0.000004351581746697425,
          -0.4085258376388174
        ],
        "max": [
          0.6500009985276486,
          1.817151405670241,
          0.5630691622911163
        ]
      }
    }
  },
  {
    "aliases": [
      "Good Morning"
    ],
    "demonstration": {
      "id": "free-glutes-bom-dia",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-bom-dia.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-glutes-bom-dia",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/free-glutes-bom-dia.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000003,
          -0.0000036985780384398377,
          -0.39804914155020027
        ],
        "max": [
          0.7500010000000001,
          1.815878161583558,
          0.5124723575341165
        ]
      }
    }
  },
  {
    "aliases": [
      "Single-Leg Stiff Deadlift"
    ],
    "demonstration": {
      "id": "free-glutes-stiff-unilateral",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-stiff-unilateral.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-glutes-stiff-unilateral",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/free-glutes-stiff-unilateral.equipment.json"
      },
      "bounds": {
        "min": [
          -0.31786075933603136,
          -0.000002564575080247217,
          -1.0559748885185534
        ],
        "max": [
          0.3608903647363984,
          1.8174570845828277,
          0.6619995162365907
        ]
      }
    }
  },
  {
    "aliases": [
      "Deficit Deadlift"
    ],
    "demonstration": {
      "id": "plan-deficit-deadlift",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-deficit-deadlift.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored plan-deficit-deadlift",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/plan-deficit-deadlift.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6500010014723522,
          -0.0000010007450580569168,
          -0.3074978771708854
        ],
        "max": [
          0.6500009985276488,
          1.9153781580195648,
          0.6349861062814832
        ]
      }
    }
  },
  {
    "aliases": [
      "Glute Bridge"
    ],
    "demonstration": {
      "id": "free-glutes-glute-bridge",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-glute-bridge.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-glutes-glute-bridge",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "bounds": {
        "min": [
          -0.4730966574485024,
          -0.0010261724035258712,
          -0.8669648911965385
        ],
        "max": [
          0.4717875609504176,
          0.5629577134830752,
          0.6988751518622012
        ]
      }
    }
  },
  {
    "aliases": [
      "Hip Thrust"
    ],
    "demonstration": {
      "id": "free-glutes-hip-thrust",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-hip-thrust.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-glutes-hip-thrust",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/free-glutes-hip-thrust.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010000000004,
          -0.000003576811485999095,
          -1.000001
        ],
        "max": [
          0.750001,
          1.0345422884308355,
          0.9288821885898738
        ]
      }
    }
  },
  {
    "aliases": [
      "Box Jump"
    ],
    "demonstration": {
      "id": "plan-box-jump",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-box-jump.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored plan-box-jump",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "box",
        "metadataUrl": "/fitness/authored/plan-box-jump.equipment.json"
      },
      "bounds": {
        "min": [
          -0.44999998807907104,
          -0.0008772027451802964,
          -0.7513204504119302
        ],
        "max": [
          0.44999998807907104,
          2.2953415843312532,
          0.7767570997186279
        ]
      }
    }
  },
  {
    "aliases": [
      "Seated Calf Raise"
    ],
    "demonstration": {
      "id": "free-legs-panturrilha-sentado",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-legs-panturrilha-sentado.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-legs-panturrilha-sentado",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "seated-calf",
        "metadataUrl": "/fitness/authored/free-legs-panturrilha-sentado.equipment.json"
      },
      "bounds": {
        "min": [
          -0.668,
          0,
          -0.772498
        ],
        "max": [
          0.668,
          1.548548,
          0.694637
        ]
      }
    }
  },
  {
    "aliases": [
      "Leg Extension"
    ],
    "demonstration": {
      "id": "free-legs-cadeira-extensora",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-legs-cadeira-extensora.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored free-legs-cadeira-extensora",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "leg-extension",
        "metadataUrl": "/fitness/authored/free-legs-cadeira-extensora.equipment.json"
      },
      "bounds": {
        "min": [
          -0.409807,
          0,
          -0.772498
        ],
        "max": [
          0.403527,
          1.548548,
          0.763672
        ]
      }
    }
  },
  {
    "aliases": [
      "Machine Abduction"
    ],
    "demonstration": {
      "id": "seated-hip-abduction",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-hip-abduction.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored seated-hip-abduction",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredLowerVariants.ts",
      "equipment": {
        "kind": "hip-abduction",
        "metadataUrl": "/fitness/authored/seated-hip-abduction.equipment.json"
      },
      "bounds": {
        "min": [
          -0.671737,
          -0.001624,
          -0.772498
        ],
        "max": [
          0.671728,
          1.548548,
          0.4477
        ]
      }
    }
  },
  {
    "aliases": [
      "Walking"
    ],
    "demonstration": {
      "id": "walking",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/walking.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored walking",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "locomotion-surface",
        "metadataUrl": "/fitness/authored/walking.equipment.json"
      },
      "bounds": {
        "min": [
          -1.250001,
          -0.008001000189989805,
          -1.7993235802577308
        ],
        "max": [
          1.250001,
          1.7828275692254452,
          1.7025493867093442
        ]
      }
    }
  },
  {
    "aliases": [
      "Running"
    ],
    "demonstration": {
      "id": "running",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/running.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored running",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "locomotion-surface",
        "metadataUrl": "/fitness/authored/running.equipment.json"
      },
      "bounds": {
        "min": [
          -1.250001,
          -0.008001000189989805,
          -1.9534454440570144
        ],
        "max": [
          1.250001,
          1.744637048536343,
          1.9395565551681255
        ]
      }
    }
  },
  {
    "aliases": [
      "Burpee"
    ],
    "demonstration": {
      "id": "burpee",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/burpee.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored burpee",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "bounds": {
        "min": [
          -0.4643795268190556,
          -0.0000010000000009468172,
          -1.05673535939381
        ],
        "max": [
          0.4642895362113272,
          2.19776335430791,
          0.7782074282612778
        ]
      }
    }
  },
  {
    "aliases": [
      "Jump Rope"
    ],
    "demonstration": {
      "id": "jump-rope",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/jump-rope.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored jump-rope",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "jump-rope",
        "metadataUrl": "/fitness/authored/jump-rope.equipment.json"
      },
      "bounds": {
        "min": [
          -0.41197364082022225,
          -0.0000010000000007349842,
          -0.9754294024238587
        ],
        "max": [
          0.4135140948461262,
          1.9294728503952026,
          1.0553879009017944
        ]
      }
    }
  },
  {
    "aliases": [
      "Battle Ropes"
    ],
    "demonstration": {
      "id": "battle-ropes",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/battle-ropes.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored battle-ropes",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "battle-ropes",
        "metadataUrl": "/fitness/authored/battle-ropes.equipment.json"
      },
      "bounds": {
        "min": [
          -0.45263854300653217,
          -9.99999999971169e-7,
          -0.16699611365640796
        ],
        "max": [
          0.45401710906170534,
          1.6822529938886635,
          3.250001
        ]
      }
    }
  },
  {
    "aliases": [
      "Treadmill"
    ],
    "demonstration": {
      "id": "treadmill",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/treadmill.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored treadmill",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "treadmill",
        "metadataUrl": "/fitness/authored/treadmill.equipment.json"
      },
      "bounds": {
        "min": [
          -0.4750010001490116,
          0.029999001341104503,
          -0.9700010286102295
        ],
        "max": [
          0.4750010001490116,
          1.942827569225445,
          0.9700010286102295
        ]
      }
    }
  },
  {
    "aliases": [
      "Stationary Bike"
    ],
    "demonstration": {
      "id": "stationary-bike",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/stationary-bike.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored stationary-bike",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "stationary-bike",
        "metadataUrl": "/fitness/authored/stationary-bike.equipment.json"
      },
      "bounds": {
        "min": [
          -0.34882812549820813,
          -9.991059303969254e-7,
          -0.5500010000000001
        ],
        "max": [
          0.35247531607798277,
          1.8777059355497583,
          0.6445407473617686
        ]
      }
    }
  },
  {
    "aliases": [
      "Elliptical"
    ],
    "demonstration": {
      "id": "elliptical",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/elliptical.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored elliptical",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "elliptical",
        "metadataUrl": "/fitness/authored/elliptical.equipment.json"
      },
      "bounds": {
        "min": [
          -0.4606999133722104,
          -9.991059303969254e-7,
          -0.7400009999999998
        ],
        "max": [
          0.45158770142973975,
          1.9558804138679824,
          0.7900009999999998
        ]
      }
    }
  },
  {
    "aliases": [
      "Stair Climber"
    ],
    "demonstration": {
      "id": "stair-climber",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/stair-climber.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored stair-climber",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "stair-climber",
        "metadataUrl": "/fitness/authored/stair-climber.equipment.json"
      },
      "bounds": {
        "min": [
          -0.5200009991059306,
          -0.0000010005960464344312,
          -0.5750010119209289
        ],
        "max": [
          0.5200009991059303,
          2.110880385257753,
          1.027501004172325
        ]
      }
    }
  },
  {
    "aliases": [
      "Rowing Machine"
    ],
    "demonstration": {
      "id": "rowing-machine",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/rowing-machine.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original authored rowing-machine",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/src/lib/fitnessAuthoredCardio.ts",
      "equipment": {
        "kind": "rowing-machine",
        "metadataUrl": "/fitness/authored/rowing-machine.equipment.json"
      },
      "bounds": {
        "min": [
          -0.43153219445840263,
          -9.991059303969254e-7,
          -1.040001
        ],
        "max": [
          0.43186789978103224,
          1.4211941048204466,
          1.2300009946355819
        ]
      }
    }
  },
  {
    "aliases": [
      "Seated Two-Hand Dumbbell Overhead Extension"
    ],
    "demonstration": {
      "id": "free-triceps-frances",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-two-hand-dumbbell-overhead-extension.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-two-hand-dumbbell-overhead-extension",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-french-final/proof/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "shared-dumbbell",
        "metadataUrl": "/fitness/authored/seated-two-hand-dumbbell-overhead-extension.equipment.json"
      },
      "bounds": {
        "min": [
          -0.2922250617102607,
          -9.999999995200982e-7,
          -0.5571017642033895
        ],
        "max": [
          0.29222794010086417,
          1.6940477068336723,
          0.8143352992774199
        ]
      }
    }
  },
  {
    "aliases": [
      "Front Raise",
      "Standing Bilateral Dumbbell Front Raise",
      "shoulders_elevacao_frontal",
      "fitness.exercises.shoulders.elevacao_frontal"
    ],
    "demonstration": {
      "id": "free-shoulders-elevacao-frontal",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-bilateral-dumbbell-front-raise.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-bilateral-dumbbell-front-raise",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v5/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-bilateral-dumbbell-front-raise.equipment.json"
      },
      "bounds": {
        "min": [
          -0.33624729203899417,
          0,
          -0.146052
        ],
        "max": [
          0.3362472904547445,
          1.815753,
          0.6096723043638833
        ]
      }
    }
  },
  {
    "aliases": [
      "Standing Straight-Bar Triceps Pressdown",
      "triceps_pulley",
      "fitness.exercises.triceps.pulley",
      "Tricep Pushdown"
    ],
    "demonstration": {
      "id": "standing-straight-bar-triceps-pressdown",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-straight-bar-triceps-pressdown.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-straight-bar-triceps-pressdown",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v5/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "cable-straight-bar",
        "metadataUrl": "/fitness/authored/standing-straight-bar-triceps-pressdown.equipment.json"
      },
      "bounds": {
        "min": [
          -0.2884907519180546,
          -9.991059303969254e-7,
          -0.135209
        ],
        "max": [
          0.28849075105092964,
          2.1700010002980235,
          1.620001
        ]
      }
    }
  },
  {
    "aliases": [
      "Arnold Press",
      "Seated Arnold Press (Back Supported)",
      "shoulders_arnold_press",
      "fitness.exercises.shoulders.arnold_press",
      "shoulders_arnold",
      "fitness.exercises.shoulders.arnold",
      "Arnold Shoulder Press"
    ],
    "demonstration": {
      "id": "seated-arnold-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-arnold-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-arnold-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v5/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/seated-arnold-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.430293,
          -9.991059303969254e-7,
          -0.575001
        ],
        "max": [
          0.430197,
          1.7802755486955757,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Preacher Curl",
      "Seated EZ-Bar Preacher Curl",
      "biceps_rosca_scott",
      "fitness.exercises.biceps.rosca_scott"
    ],
    "demonstration": {
      "id": "free-biceps-rosca-scott",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-ez-bar-preacher-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-ez-bar-preacher-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v9/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "preacher-ez-bar",
        "metadataUrl": "/fitness/authored/seated-ez-bar-preacher-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6018714191540151,
          -0.000001,
          -0.4700009999999999
        ],
        "max": [
          0.5981305808459852,
          1.281848,
          0.9447351150549214
        ]
      }
    }
  },
  {
    "aliases": [
      "Close-Grip Bench Press",
      "Close-grip Barbell Bench Press",
      "triceps_supino_fechado",
      "fitness.exercises.triceps.supino_fechado",
      "Close-Grip Bench"
    ],
    "demonstration": {
      "id": "close-grip-bench-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/close-grip-bench-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored close-grip-bench-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v9/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/close-grip-bench-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6200010002666546,
          -9.991059303969254e-7,
          -1.140001
        ],
        "max": [
          0.6200010002666546,
          1.2327511382557061,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Shrugs",
      "Standing Dumbbell Shrug",
      "shoulders_encolhimento",
      "fitness.exercises.shoulders.encolhimento"
    ],
    "demonstration": {
      "id": "free-shoulders-encolhimento",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-dumbbell-shrug.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-dumbbell-shrug",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v9/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/standing-dumbbell-shrug.equipment.json"
      },
      "bounds": {
        "min": [
          -0.33929655069108566,
          0,
          -0.15484877397432978
        ],
        "max": [
          0.32931307146842886,
          1.815753,
          0.174585
        ]
      }
    }
  },
  {
    "aliases": [
      "Rear Delt Raise",
      "Bent-over Bilateral Dumbbell Rear Delt Raise",
      "shoulders_elevacao_posterior",
      "fitness.exercises.shoulders.elevacao_posterior"
    ],
    "demonstration": {
      "id": "free-shoulders-elevacao-posterior",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/bent-over-bilateral-dumbbell-rear-delt-raise.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored bent-over-bilateral-dumbbell-rear-delt-raise",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v10/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/bent-over-bilateral-dumbbell-rear-delt-raise.equipment.json"
      },
      "bounds": {
        "min": [
          -0.8146168715980285,
          -0.000001,
          -0.292091
        ],
        "max": [
          0.8087468125712304,
          1.363585,
          0.623091
        ]
      }
    }
  },
  {
    "aliases": [
      "Cable Curl",
      "Standing Low-Cable Straight-Bar Curl",
      "biceps_rosca_polia",
      "fitness.exercises.biceps.rosca_polia"
    ],
    "demonstration": {
      "id": "free-biceps-rosca-polia",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-low-cable-straight-bar-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-low-cable-straight-bar-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-nine-final/generations/v10/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "cable-straight-bar",
        "metadataUrl": "/fitness/authored/standing-low-cable-straight-bar-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.28849075194993046,
          -9.991059303969254e-7,
          -0.14597
        ],
        "max": [
          0.2884907510828057,
          1.9500009999999999,
          1.620001
        ]
      }
    }
  },
  {
    "aliases": [
      "Bench Dip",
      "Bent-Knee Bench Dip",
      "triceps_banco",
      "fitness.exercises.triceps.banco"
    ],
    "demonstration": {
      "id": "free-triceps-banco",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/bent-knee-bench-dip.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored bent-knee-bench-dip",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-bench-dip-v16-final/generations/v16/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "bench",
        "metadataUrl": "/fitness/authored/bent-knee-bench-dip.equipment.json"
      },
      "bounds": {
        "min": [
          -0.450000988079071,
          -0.000001,
          -0.9000009999999999
        ],
        "max": [
          0.450000988079071,
          1.513548,
          0.724336
        ]
      }
    }
  },
  {
    "aliases": [
      "21s Curl",
      "Standing Barbell 21s Curl Protocol",
      "biceps_rosca_21",
      "fitness.exercises.biceps.rosca_21"
    ],
    "demonstration": {
      "id": "free-biceps-rosca-21",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-barbell-21s-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-barbell-21s-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-natural-21s-final/generations/v10/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/standing-barbell-21s-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.6584907519499275,
          0,
          -0.14597
        ],
        "max": [
          0.6584907510828027,
          1.815753,
          0.490386955367167
        ]
      }
    }
  },
  {
    "aliases": [
      "Upright Row",
      "Standing wide-grip barbell upright row to chest",
      "shoulders_remada_alta",
      "fitness.exercises.shoulders.remada_alta"
    ],
    "demonstration": {
      "id": "free-shoulders-remada-alta",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-barbell-upright-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-barbell-upright-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-upright-chest-v1-final/generations/chest-v1/frozen-inputs/src/lib/fitnessAuthoredArmVariants.ts",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/standing-barbell-upright-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7900010000000001,
          0,
          -0.164573
        ],
        "max": [
          0.7900010000000001,
          1.815753,
          0.3200010005960464
        ]
      }
    }
  },
  {
    "aliases": [
      "Flat-Bench Two-Hand Dumbbell Pullover",
      "chest_pullover",
      "fitness.exercises.chest.pullover"
    ],
    "demonstration": {
      "id": "flat-two-hand-dumbbell-pullover",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/flat-two-hand-dumbbell-pullover.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored flat-two-hand-dumbbell-pullover",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/pullover-v2-independent-reviewed/reproduce-from-archive.py",
      "equipment": {
        "kind": "shared-dumbbell",
        "metadataUrl": "/fitness/authored/flat-two-hand-dumbbell-pullover.equipment.json"
      },
      "bounds": {
        "min": [
          -0.292225,
          -0.000001,
          -1.162555
        ],
        "max": [
          0.292227,
          1.0858950759053165,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Pelvic Raise",
      "glutes_elevacao_pelvica",
      "fitness.exercises.glutes.elevacao_pelvica"
    ],
    "demonstration": {
      "id": "free-glutes-elevacao-pelvica",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-elevacao-pelvica.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored free-glutes-elevacao-pelvica",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/advanced-unloaded-two-v6-v7/raw/source/free-glutes-elevacao-pelvica-fitnessAuthoredLowerAdvanced.ts.inert.txt",
      "equipment": {
        "kind": "bench",
        "metadataUrl": "/fitness/authored/free-glutes-elevacao-pelvica.equipment.json"
      },
      "bounds": {
        "min": [
          -0.500001,
          -0.000004392767337915542,
          -1.000001
        ],
        "max": [
          0.500001,
          1.0344422718369024,
          0.9288827422434297
        ]
      }
    }
  },
  {
    "aliases": [
      "Single-Leg Bulgarian Split Squat",
      "glutes_bulgaro_unilateral",
      "fitness.exercises.glutes.bulgaro_unilateral"
    ],
    "demonstration": {
      "id": "free-glutes-bulgaro-unilateral",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-bulgaro-unilateral.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored free-glutes-bulgaro-unilateral",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/advanced-unloaded-two-v6-v7/raw/source/free-glutes-bulgaro-unilateral-fitnessAuthoredLowerAdvanced.ts.inert.txt",
      "equipment": {
        "kind": "bench",
        "metadataUrl": "/fitness/authored/free-glutes-bulgaro-unilateral.equipment.json"
      },
      "bounds": {
        "min": [
          -0.40000100596046445,
          -0.000011953188987898209,
          -1.350001
        ],
        "max": [
          0.40000100596046445,
          1.7685411023364288,
          0.548881740774466
        ]
      }
    }
  },
  {
    "aliases": [
      "Seated Pec Deck",
      "chest_peck_deck",
      "fitness.exercises.chest.peck_deck"
    ],
    "demonstration": {
      "id": "seated-forearm-pad-pec-deck",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-forearm-pad-pec-deck.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored seated-forearm-pad-pec-deck",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/machine-two-pec-press-independent-reviewed/reproduce-from-archive.py",
      "equipment": {
        "kind": "pec-deck",
        "metadataUrl": "/fitness/authored/seated-forearm-pad-pec-deck.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7351379975931646,
          -9.991059303969254e-7,
          -1.0572508741630595
        ],
        "max": [
          0.7384957360606065,
          2.2712224269773333,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Seated Machine Chest Press",
      "chest_supino_maquina",
      "fitness.exercises.chest.supino_maquina"
    ],
    "demonstration": {
      "id": "seated-machine-chest-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-machine-chest-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored seated-machine-chest-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/machine-two-pec-press-independent-reviewed/reproduce-from-archive.py",
      "equipment": {
        "kind": "chest-press-machine",
        "metadataUrl": "/fitness/authored/seated-machine-chest-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.433862,
          -9.991059303969254e-7,
          -0.700001
        ],
        "max": [
          0.433426,
          1.725001000372529,
          0.814335
        ]
      }
    }
  },
  {
    "aliases": [
      "Concentration Curl",
      "seated-one-arm-dumbbell-concentration-curl",
      "biceps_rosca_concentrada",
      "fitness.exercises.biceps.rosca_concentrada"
    ],
    "demonstration": {
      "id": "free-biceps-rosca-concentrada",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-one-arm-dumbbell-concentration-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored seated-one-arm-dumbbell-concentration-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-concentration-v37-final/reproduce.cjs",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/seated-one-arm-dumbbell-concentration-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.46759600824711506,
          -0.000001,
          -0.4700009999999999
        ],
        "max": [
          0.447244,
          0.932575,
          0.9564972541523782
        ]
      }
    }
  },
  {
    "aliases": [
      "free-back-puxada-frontal",
      "seated-front-lat-pulldown",
      "Lat Pulldown",
      "back_puxada_frontal",
      "fitness.exercises.back.puxada_frontal"
    ],
    "demonstration": {
      "id": "free-back-puxada-frontal",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-front-lat-pulldown.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored seated-front-lat-pulldown",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/machine-two-lat-full-return-v3-weld-v4-independent-reviewed/reproduce-from-archive.py",
      "equipment": {
        "kind": "lat-pulldown",
        "metadataUrl": "/fitness/authored/seated-front-lat-pulldown.equipment.json"
      },
      "bounds": {
        "min": [
          -0.5301702904427971,
          -0.000001,
          -0.4900009999999999
        ],
        "max": [
          0.5301702904427971,
          2.1050010003725292,
          1.350001
        ]
      }
    }
  },
  {
    "aliases": [
      "free-back-puxada-triangulo",
      "seated-neutral-close-grip-pulldown",
      "Close-Grip Lat Pulldown",
      "back_puxada_triangulo",
      "fitness.exercises.back.puxada_triangulo"
    ],
    "demonstration": {
      "id": "free-back-puxada-triangulo",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-neutral-close-grip-pulldown.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored seated-neutral-close-grip-pulldown",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/machine-two-lat-full-return-v3-weld-v4-independent-reviewed/reproduce-from-archive.py",
      "equipment": {
        "kind": "lat-pulldown",
        "metadataUrl": "/fitness/authored/seated-neutral-close-grip-pulldown.equipment.json"
      },
      "bounds": {
        "min": [
          -0.3500009991059303,
          -0.000001,
          -0.4900009999999999
        ],
        "max": [
          0.3500009991059303,
          2.1050010003725292,
          1.350001
        ]
      }
    }
  },
  {
    "aliases": [
      "free-biceps-rosca-cabo",
      "standing-low-cable-rope-curl",
      "Cable Rope Curl",
      "biceps_rosca_cabo",
      "fitness.exercises.biceps.rosca_cabo"
    ],
    "demonstration": {
      "id": "free-biceps-rosca-cabo",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-low-cable-rope-curl.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-low-cable-rope-curl",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-rope-two-v8-final/producer/reproduce.cjs",
      "equipment": {
        "kind": "cable",
        "metadataUrl": "/fitness/authored/standing-low-cable-rope-curl.equipment.json"
      },
      "bounds": {
        "min": [
          -0.274215,
          -9.991059303969254e-7,
          -0.145781
        ],
        "max": [
          0.274572,
          1.815753,
          1.600001
        ]
      }
    }
  },
  {
    "aliases": [
      "free-triceps-corda",
      "standing-rope-triceps-pushdown",
      "Triceps Rope Pushdown",
      "triceps_corda",
      "fitness.exercises.triceps.corda"
    ],
    "demonstration": {
      "id": "free-triceps-corda",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-rope-triceps-pushdown.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored standing-rope-triceps-pushdown",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/arm-rope-two-v8-final/producer/reproduce.cjs",
      "equipment": {
        "kind": "cable",
        "metadataUrl": "/fitness/authored/standing-rope-triceps-pushdown.equipment.json"
      },
      "bounds": {
        "min": [
          -0.276748,
          -9.991059303969254e-7,
          -0.145541
        ],
        "max": [
          0.277249,
          2.1700010002980235,
          1.600001
        ]
      }
    }
  },
  {
    "aliases": [
      "free-legs-hack-squat",
      "Hack Squat",
      "legs_hack_squat",
      "fitness.exercises.legs.hack_squat"
    ],
    "demonstration": {
      "id": "free-legs-hack-squat",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-legs-hack-squat.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored free-legs-hack-squat",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/advanced-closed-three-v10/reproduce.py",
      "equipment": {
        "kind": "hack-squat",
        "metadataUrl": "/fitness/authored/free-legs-hack-squat.equipment.json"
      },
      "bounds": {
        "min": [
          -0.46812378483882144,
          -0.0000010014901161138336,
          -1.237097953910651
        ],
        "max": [
          0.46795567833989055,
          1.6142415684135623,
          0.650001011920929
        ]
      }
    }
  },
  {
    "aliases": [
      "free-glutes-kickback",
      "Glute Kickback",
      "glutes_kickback",
      "fitness.exercises.glutes.kickback"
    ],
    "demonstration": {
      "id": "free-glutes-kickback",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/free-glutes-kickback.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored free-glutes-kickback",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/advanced-closed-three-v10/reproduce.py",
      "equipment": {
        "kind": "ankle-cable",
        "metadataUrl": "/fitness/authored/free-glutes-kickback.equipment.json"
      },
      "bounds": {
        "min": [
          -0.49165635601304647,
          -9.991059303969254e-7,
          -0.6363846008282601
        ],
        "max": [
          0.4917098019419653,
          1.77006205372164,
          1.074001001400709
        ]
      }
    }
  },
  {
    "aliases": [
      "plan-kettlebell-swing",
      "Kettlebell Swing",
      "Kettlebell Swing"
    ],
    "demonstration": {
      "id": "plan-kettlebell-swing",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-kettlebell-swing.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored plan-kettlebell-swing",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/advanced-closed-three-v10/reproduce.py",
      "equipment": {
        "kind": "kettlebell",
        "metadataUrl": "/fitness/authored/plan-kettlebell-swing.equipment.json"
      },
      "bounds": {
        "min": [
          -0.35223050065900696,
          -0.000005670594221953163,
          -0.3701458473418538
        ],
        "max": [
          0.35223336908778774,
          1.799998049663089,
          0.8231556364343311
        ]
      }
    }
  },
  {
    "aliases": [
      "Walking Lunges",
      "plan-walking-lunges"
    ],
    "demonstration": {
      "id": "plan-walking-lunges",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-walking-lunges.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored plan-walking-lunges",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/codex/vyv-fitness-rea-20261015/docs/qa/fitness-completion-20261015/walking-lunges-original-v5/reproduce.py",
      "bounds": {
        "min": [
          -0.3644441999275663,
          0.000020136940938462883,
          -0.1453247472474628
        ],
        "max": [
          0.3649678101009745,
          1.809656803535007,
          1.4676241763074427
        ]
      }
    }
  },
  {
    "aliases": [
      "Bent-Over Bilateral Dumbbell Row"
    ],
    "demonstration": {
      "id": "bent-over-bilateral-dumbbell-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/bent-over-bilateral-dumbbell-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored bent-over-bilateral-dumbbell-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/f9534078045c15d4b6ed2865f0895c346c92d813/docs/qa/fitness-completion-20261015/bilateral-dumbbell-row13/author-reproducer/reproduce.cjs",
      "equipment": {
        "kind": "dumbbells",
        "metadataUrl": "/fitness/authored/bent-over-bilateral-dumbbell-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.400620685543393,
          -0.000001016940352151437,
          -0.292253536146079
        ],
        "max": [
          0.39069516575563606,
          1.3130972863032506,
          0.6142682281721917
        ]
      }
    }
  },
  {
    "aliases": [
      "Standing High-Pulley Cable Crossover"
    ],
    "demonstration": {
      "id": "standing-high-cable-crossover",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-high-cable-crossover.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored standing-high-cable-crossover",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/d90b2d1a336b02b341c77c3f076497acdcd5dc3a/docs/qa/fitness-completion-20261015/dual-cable-two-original-v15/reproduce-from-archive.py#standing-high-cable-crossover",
      "equipment": {
        "kind": "dual-cable",
        "metadataUrl": "/fitness/authored/standing-high-cable-crossover.equipment.json"
      },
      "bounds": {
        "min": [
          -1.1600009991059304,
          -9.991059303969254e-7,
          -0.6500009999999999
        ],
        "max": [
          1.1600009991059304,
          2.0050009997019766,
          0.466413
        ]
      }
    }
  },
  {
    "aliases": [
      "Standing Chest-Height Cable Fly"
    ],
    "demonstration": {
      "id": "standing-chest-height-cable-fly",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-chest-height-cable-fly.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV private authored standing-chest-height-cable-fly",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/d90b2d1a336b02b341c77c3f076497acdcd5dc3a/docs/qa/fitness-completion-20261015/dual-cable-two-original-v15/reproduce-from-archive.py#standing-chest-height-cable-fly",
      "equipment": {
        "kind": "dual-cable",
        "metadataUrl": "/fitness/authored/standing-chest-height-cable-fly.equipment.json"
      },
      "bounds": {
        "min": [
          -1.1600009991059304,
          -9.991059303969254e-7,
          -0.6500009999999999
        ],
        "max": [
          1.1600009991059304,
          1.736255,
          0.582757
        ]
      }
    }
  },
  {
    "aliases": [
      "Seated Neutral-Grip Cable Row"
    ],
    "demonstration": {
      "id": "seated-neutral-cable-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/seated-neutral-cable-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored corrected seated-neutral-cable-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/cable-rows-two-c9/reproduction/reproduce.py#seated-neutral-cable-row",
      "equipment": {
        "kind": "low-cable-row",
        "metadataUrl": "/fitness/authored/seated-neutral-cable-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.300002,
          -1e-06,
          -0.49000099999999996
        ],
        "max": [
          0.300002,
          1.508549,
          1.6300009999999998
        ]
      }
    }
  },
  {
    "aliases": [
      "Standing Bilateral Cable Row"
    ],
    "demonstration": {
      "id": "standing-bilateral-cable-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/standing-bilateral-cable-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored corrected standing-bilateral-cable-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/cable-rows-two-c9/reproduction/reproduce.py#standing-bilateral-cable-row",
      "equipment": {
        "kind": "low-cable-row",
        "metadataUrl": "/fitness/authored/standing-bilateral-cable-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.26551199999999997,
          -2e-06,
          -0.173198
        ],
        "max": [
          0.274937,
          1.792705,
          1.6300009999999998
        ]
      }
    }
  },
  {
    "aliases": [
      "Landmine Neutral-Grip T-Bar Row"
    ],
    "demonstration": {
      "id": "landmine-neutral-t-bar-row",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/landmine-neutral-t-bar-row.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored corrected landmine-neutral-t-bar-row",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/landmine-rigid-natural18-44825/reproduce.py#landmine-neutral-t-bar-row",
      "equipment": {
        "kind": "landmine-row",
        "metadataUrl": "/fitness/authored/landmine-neutral-t-bar-row.equipment.json"
      },
      "bounds": {
        "min": [
          -0.31165499999999996,
          -1e-06,
          -2.070001
        ],
        "max": [
          0.284228,
          1.403179,
          0.600584
        ]
      }
    }
  },
  {
    "aliases": [
      "Weighted Pull-up"
    ],
    "demonstration": {
      "id": "plan-weighted-pull-up",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-weighted-pull-up.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored weighted-strict-pronated-pull-up",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/weighted-pull-up-natural18-v15/reproduce.py#plan-weighted-pull-up",
      "equipment": {
        "kind": "weighted-pull-up",
        "metadataUrl": "/fitness/authored/plan-weighted-pull-up.equipment.json"
      },
      "bounds": {
        "min": [
          -0.740001,
          -1e-06,
          -0.210001
        ],
        "max": [
          0.740001,
          2.374541,
          0.490001
        ]
      }
    }
  },
  {
    "aliases": [
      "Clean and Press"
    ],
    "demonstration": {
      "id": "plan-clean-and-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-clean-and-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV original Clean and STRICTpress private205 directed receiving full14",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/original-clean-and-strict-press205-v2/reproduce.py#plan-clean-and-press",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/plan-clean-and-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.751000001472352,
          -0.0009676340311782838,
          -0.30024681474023557
        ],
        "max": [
          0.751,
          2.268562253527835,
          0.6463196796863752
        ]
      }
    }
  },
  {
    "aliases": [
      "Push Press"
    ],
    "demonstration": {
      "id": "plan-push-press",
      "modelOffsetY": 0,
      "assetUrl": "/fitness/authored/plan-push-press.glb",
      "modelUrl": "/avatar/model_small.glb",
      "clipName": "VYV authored plan-push-press",
      "quality": "technical-preview",
      "sourceUrl": "https://github.com/82rmartins/vyv-mirror-ai/blob/4104a3b504eaf5936f54d463a28a153699337c04/docs/qa/fitness-completion-20261015/advanced-push-press-v14/reproduce.py#plan-push-press",
      "equipment": {
        "kind": "barbell",
        "metadataUrl": "/fitness/authored/plan-push-press.equipment.json"
      },
      "bounds": {
        "min": [
          -0.7500010004229948,
          2.9515416872246105e-05,
          -0.22200255673167732
        ],
        "max": [
          0.750001,
          2.276993101673811,
          0.3168104813554445
        ]
      }
    }
  }
];
const normalize = (value: string) => value.normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase().replace(/[^a-z0-9]+/gu, " ").trim();
const byAlias = new Map<string, ExerciseAvatarDemonstration>();
const byId = new Map(catalog.map(item => [item.demonstration.id, item.demonstration]));
for (const item of catalog) for (const alias of item.aliases) byAlias.set(normalize(alias), item.demonstration);
export function getAuthoredFitnessDemonstration(value: string): ExerciseAvatarDemonstration | null {
  return byId.get(value) ?? byAlias.get(normalize(value)) ?? null;
}
